import { SystemStyleObject } from '@chakra-ui/react'

export const calenderStyle: SystemStyleObject | undefined = {
  '.react-datepicker': {
    border: 'none',
  },
  '.react-datepicker__header': {
    bgColor: 'transparent',
    border: 'none',
  },
  '.react-datepicker__day--in-range': {
    bgColor: '#e3f4ff',
    color: 'inherit',
  },
  '.react-datepicker__day': {
    borderRadius: 0,
    fontSize: '12px',
    fontFamily: 'body',
  },
  '.react-datepicker__day:not(:empty)': {
    m: '0',
    w: '32px',
    h: '32px',
    lineHeight: '32px',
  },
  '.react-datepicker__day--selected': {
    borderRadius: 'full',
    bgColor: '#4199d5',
  },
  '.react-datepicker__day--range-start': {
    bgColor: '#4199d5',
    color: '#fff',
    borderLeftRadius: 'md',
    borderRightRadius: 0,
  },
  '.react-datepicker__day--range-end': {
    bgColor: '#4199d5',
    color: '#fff',
    borderRightRadius: 'md',
  },
  '.react-datepicker__day--selecting-range-start': {
    borderLeftRadius: 'md',
    borderRightRadius: 0,
  },
  '.react-datepicker__day--in-selecting-range': {
    bgColor: '#e3f4ff',
    color: 'inherit',
  },
  '.react-datepicker__day--in-selecting-range.react-datepicker__day--selected':
    {
      bgColor: '#4199d5',
      color: '#fff',
    },
  '.react-datepicker__day--today': {
    fontWeight: 'normal',
  },
  '.react-datepicker__day-name': {
    m: 0,
    w: '32px',
    fontWeight: 'bold',
    fontSize: '0.8rem',
  },
  '.react-datepicker__current-month': {
    borderBottom: '1px solid',
    borderBottomColor: 'gray.150',
    pb: 3,
    mb: 3,
  },
  '.react-datepicker__month-container': {
    px: 3,
    borderLeft: '1px solid',
    borderLeftColor: 'gray.150',
  },
}
